import { render } from "./CatalogCrudView.vue?vue&type=template&id=7fc6aedb"
import script from "./CatalogCrudView.vue?vue&type=script&lang=js"
export * from "./CatalogCrudView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__